export type QueuedUpload = {
  id: string;
  batchId: string;
  sourceSlug: string;
  parentGallerySlugs: string[];
  file: File;
  state: "queued" | "processing" | "failed";
  error?: string;
};

const DB = "hvozdany-photo-queue";
const STORE = "uploads";

function open() {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { keyPath: "id" });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function queuePut(item: QueuedUpload) {
  const db = await open();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(item);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  db.close();
}

export async function queueList() {
  const db = await open();
  const items = await new Promise<QueuedUpload[]>((resolve, reject) => {
    const request = db.transaction(STORE).objectStore(STORE).getAll();
    request.onsuccess = () => resolve(request.result as QueuedUpload[]);
    request.onerror = () => reject(request.error);
  });
  db.close();
  return items;
}

export async function queueDelete(id: string) {
  const db = await open();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  db.close();
}
